import { useState } from "react";
import { Container, Col, Row, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list";
import * as tags from "@repoflow/form-schema/widgets/tag";
import * as OrganizationKeyQL from "queries/organization-key";
import * as Section from "@repoflow/components/section";
import * as KeyAccess from "components/key-access";

export const Sidebar = () => null;

// The section that owns this page draws the "API Keys" crumb, so there is
// nothing left for the list itself to add.
export const Indice = () => null;

const FilterField = ({ id, label, value, onChange, placeholder }) => (
  <FormGroup className="mr-2">
    <Label for={id} className="mr-2">
      {label}
    </Label>
    <Input id={id} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
  </FormGroup>
);

/**
 * Narrow the listing to agent keys: a kind of scope — service and type, as
 * the keys were minted with — and optionally one resource of it. Applied on
 * submit, not per keystroke — each change is a new listing from the first page.
 */
export const ScopeFilter = ({ onApply }) => {
  const [agent, setAgent] = useState(false);
  const [service, setService] = useState("");
  const [type, setType] = useState("");
  const [id, setId] = useState("");
  const scope = agent ? KeyAccess.scopeFilter({ service, type, id }) : null;

  return (
    <Form
      inline
      aria-label="Filter keys"
      onSubmit={(e) => {
        e.preventDefault();
        onApply(scope);
      }}
    >
      <FormGroup className="mr-2">
        <Label for="key-filter-kind" className="mr-2">
          Show
        </Label>
        <Input
          type="select"
          id="key-filter-kind"
          value={agent ? "agent" : ""}
          onChange={(e) => setAgent(e.target.value === "agent")}
        >
          <option value="">All keys</option>
          <option value="agent">Agent keys</option>
        </Input>
      </FormGroup>
      {agent && (
        <>
          <FilterField id="key-filter-service" label="Service" value={service} onChange={setService} />
          <FilterField id="key-filter-type" label="Type" value={type} onChange={setType} />
          <FilterField id="key-filter-id" label="Resource id" value={id} onChange={setId} placeholder="Any" />
        </>
      )}
      {/* An agent filter needs a service and a type: keys.list filters by kind. */}
      <Button type="submit" color="secondary" disabled={agent && !scope}>
        Filter
      </Button>
    </Form>
  );
};

export const Content = ({ match: { params } }) => {
  const { base, schema } = Section.useSectionContext();
  // The `scope` argument of keys.list, or null for every key. The unfiltered
  // listing is the document it always was, five to a page; a filtered one is
  // `listScoped` — docs/scoped-keys.md §Listing by scope.
  const [scope, setScope] = useState(null);

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add API Key
          </Link>
        </Col>
        <Col xs="auto">
          <ScopeFilter onApply={setScope} />
        </Col>
      </Row>

      <div className="mt-4"></div>

      {/* Keyed on the filter: List accumulates pages in its own state, and
          would otherwise append the filtered listing to the unfiltered one. */}
      <List
        key={JSON.stringify(scope)}
        path={"viewer.account.domains.get.organizations.get.keys"}
        query={scope ? OrganizationKeyQL.listScoped : OrganizationKeyQL.list}
        variables={scope ? { ...params, scope } : params}
        schema={schema}
        target={{ $ref: "/Public/Key" }}
        empty={scope ? "No agent keys match." : "No API keys yet."}
        widgets={{ tags, ...KeyAccess.widgets }}
        config={{
          "/Public/Key": {
            fields: [KeyAccess.keyIdColumn, "roles", "createdAt"],
          },
        }}
        content={({ item: { keyId } }) => (
          <Link className={"btn btn-primary"} to={`${base}/${keyId}`}>
            View
          </Link>
        )}
      />
    </Container>
  );
};
